import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import {
  Box,
  Typography,
  Button,
  IconButton,
  useMediaQuery,
  Collapse,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import HaveQuestions from "./components/HaveQuestions";
import DAMJourneyinfographic from "./assets/Home/DAMJourneyinfographic.png";
import DAMPracticeInfographic from "./assets/Home/DAMPracticeInfographic.png";
import DataServicesInfographic from "./assets/Home/DataServicesInfographic.png";
import ImmersiveExperienceInfographic from "./assets/Home/ImmersiveExperienceInfographic.png";
import IndependentInfographic from "./assets/Home/IndependentInfographic.png";
import TriangleOnGrey from "./assets/Home/TriangleOnGrey.png";
import TriangleOnWhite from "./assets/Home/TriangleOnWhite.png";
import quoteImg from "./assets/qute.png";
import logo from "./assets/watermarkLogo.png";
import bottomLeftDots from "./assets/bottomLeftDots.png";
import topRightDots from "./assets/topRightDots.png";
import homeHeroBanner from "./assets/homeHeroBanner.png";
import GradientIcon from "./components/GradientIcon";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import LocalHospitalOutlinedIcon from "@mui/icons-material/LocalHospitalOutlined";
import BiotechOutlinedIcon from "@mui/icons-material/BiotechOutlined";
import SignalCellularAltOutlinedIcon from "@mui/icons-material/SignalCellularAltOutlined";
import ElectricBoltOutlinedIcon from "@mui/icons-material/ElectricBoltOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import PlayCircleOutlinedIcon from "@mui/icons-material/PlayCircleOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import NewspaperOutlinedIcon from "@mui/icons-material/NewspaperOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import MemoryOutlinedIcon from "@mui/icons-material/MemoryOutlined";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";

const gradientHoverSx = {
  position: "relative",
  border: "1px solid transparent",
  backgroundClip: "padding-box",
  transition: "all 0.3s ease",
  "&:hover::before": {
    opacity: 1,
  },
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    borderRadius: "8px",
    padding: "2px",
    background: "linear-gradient(90deg, #FF7FAC, #5834BA)",
    WebkitMask:
      "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
    WebkitMaskComposite: "xor",
    maskComposite: "exclude",
    opacity: 0,
    transition: "opacity 0.3s ease",
  },
};
const historyData = [
  {
    year: "1996",
    text:
      "Engineered and launched a scalable digital asset repository for a global sports media platform, centralizing high-res imagery and digitized historical artifacts.",
  },
  {
    year: "1998",
    text:
      "Conceptualized and spearheaded the design and launch of a pioneering digital asset management and eCommerce system for handmade rugs (eRugGallery.com). Developed a comprehensive rug taxonomy, established digital imaging standards, and built a patented search algorithm. The system integrated rug attributes with real-time inventory to deliver search results in less than a second. Successfully secured a USPTO patent for the proprietary search algorithm and attribute system.",
    mobileText:
      "Conceptualized and spearheaded the design and launch of a pioneering digital asset management and eCommerce system for handmade rugs. Successfully secured a USPTO patent for a proprietary search algorithm and attribute system.",
  },
  {
    year: "2000",
    text:
      "Developed an internal, directory-based DAM system that powered dynamic image delivery, streamlining and accelerating the asset publishing pipeline across diverse client websites.",
  },
  {
    year: "2003",
    text:
      "Developed PTracker, a full-scale project management web application for software teams featuring a built-in DAM module, addressing feature gaps in newly launched Jira software.",
  },
  {
    year: "2004",
    text:
      "Developed pyRoze, an early Python-based CMS featuring a built-in DAM module and a structured XML schema to drive component-driven web content publishing.",
  },
  {
    year: "2005",
    text:
      "Conceptualized, proposed, and secured a $2M funding to develop PLOSOne.org, the first unified CMS and Journal Management System (JMS) in the scientific journal publishing space. The pioneering platform utilized Semantic Web standards and an embedded DAM framework to manage and search millions of digital assets.",
  },
  {
    year: "2007",
    text:
      "Architected a proprietary DAM platform named Client Vault and a custom issue-tracking system, pioneering document production workflows and secure sharing for engineering teams before the advent of commercial storage platforms.",
  },
  {
    year: "2009",
    text:
      "Developed CrowdApproved, a commercial DAM platform enabling advertising agencies to securely distribute design artifacts and consolidate client feedback. Pioneered the first social collaboration framework dedicated to group reviews of marketing collateral and approval workflows for creative assets.",
  },
  {
    year: "2010",
    text:
      'CFDCalc — Designed and rolled out the first on-demand and fully scaled PaaS-based service in the field of Computational Fluid Dynamics (CFD) enabling CFD developers worldwide to deploy their engineering solutions on the CFDCalc platform through mini apps called "Calculators" by utilizing HPC on AWS EC2 & S3.',
  },
  {
    year: "2012",
    text:
      "BraimWard — A private Social Media platform for individuals and small businesses offering nine content categories: blog, video, music, photo, gallery, links, quotes, cartoon, and survey. Contributors manage their digital publications on the platform.",
  },
  {
    year: "2013",
    text:
      "A TV Series platform. It is the next generation of legacy IMDb. Integrated with the BraimWard platform driving fan interests into their favorite TV series.",
  },
  {
    year: "2014-1",
    text:
      "Developed a DAM platform for the Gobel Group, the leading consulting and technology firm working exclusively in the healthcare philanthropy sector. The platform offers video-on-demand service and a digital assets repository. Implemented a permission structure to partition videos by hospital organizations.",
  },
  {
    year: "2014-2",
    text:
      'Developed a portal to promote and facilitate information dissemination for a fund-raising campaign online for the production of a pilot for an adventure TV series named "Billy and the Bandit."',
  },
  {
    year: "2015",
    text:
      "Leveraging Adobe Experience Manager (AEM) DAM, migrated digital assets of a sales enablement application from a third-party service to a custom-developed in-house DAM repository. Supported content publishers, document owners, product marketing managers, and sales engineers to self-publish 4,000 assets through Document Submission and Document Revision portals.",
  },
  {
    year: "2016",
    text:
      "Client Mosaic Development Systems engaged DAM Journey to develop a SaaS-based Customer Experience Management (CEM) system for the banking and credit union industry. An analytic system that measured customer experience as they interacted with bank employees.",
  },
  {
    year: "2017",
    text:
      "Consulted with a financial client to conduct a full discovery and gather requirements for a personal wealth management lifecycle product. Developed the UI for over 300 pages and specified the custom build of a DAM system to securely handle financial documents.",
  },
  {
    year: "2018",
    text:
      "Charter Communications. Supported enterprise digital publishing platforms known as Spectrum News and Sports, broadcasting and publishing news and sports content in 12 local markets and to 10 million users weekly. Managed a volume of 5 million digital assets as various documents and videos.",
  },
  {
    year: "2019",
    text:
      "TD Ameritrade. Unified 12 departments running different digital repositories into one central DAM system. Directed discovery workshops, metadata strategy, enterprise taxonomy development, and migration planning ingesting more than 100,000 digital assets.",
  },
  {
    year: "2020",
    text:
      "ServiceNow engagement. Leveraging the Product Manager role, integrated a newly-acquired AI-driven search engine into ServiceNow's external customer community. Ingested data sets from Knowledge Management, Help Center, Service Catalog, Community, Media Assets, and Developers Portal to create a consistent search experience.",
  },
  {
    year: "2021",
    text:
      "Alexander's Studio. Bringing the world's largest legacy commercial animation library to market in a DAM system. Recapitalizing and bringing back to life a powerhouse media, advertising, and animation studio whose commercial library is the largest of its kind anywhere in the world. It contains the work of some of the most famous animators, Academy Award winners, directors and producers of the 20th, 21st, and mid-century modern eras.",
  },
  {
    year: "2022",
    text:
      "Performed extensive discovery and usability testing with dedicated fans in England to refine the user experience of the next generation football (soccer) platform branded as Predictal. The platform manages a Starting XI prediction system combining gamification, personalization, and data visualization within a unique community-engaged experience.",
  },
  {
    year: "2023",
    text:
      "Conducted UAT of the Predictal platform during Season 2023-24 of the English Premier League. Real data, real fans, live predictions.",
  },
  {
    year: "2024-1",
    text:
      "Client ASVPM.org engaged DAM Journey to lead product strategy and development of a unique Immersive Experience educational life cycle management platform named APIE. Built out the full platform in just 6 months and on budget.",
  },
  {
    year: "2024-2",
    text:
      "Consulted with Culligan International helping in enterprise product modernization of global content operations through implementation of a Digital Asset Management platform supporting marketing operations, creative operations, and digital assets governance. Deployed Brandfolder DAM product and configured it across 12 global business units, establishing a unified content ecosystem and managing 10,000+ digital assets.",
  },
  {
    year: "2025",
    text:
      "Led product development of an AI-enabled marketplace platform for used toys integrating eCommerce, enterprise search, Digital Asset Management, and workflow automation. Built an AI-enabled DAM identifying digital asset attributes and recognizing the image.",
  },
  {
    year: "2026-1",
    text:
      "Strategic product discovery engagement to modernize Moderna's enterprise CMS platform supporting global regulated content publishing and Medical Legal Review (MLR) workflows. Evaluated existing CMS architecture, Veeva integrations, and Medical Legal Review workflows to identify opportunities for workflow simplification, improved governance, and enhanced regulatory compliance.",
  },
  {
    year: "2026-2",
    text:
      "DAM Discovery Framework — Building the first all-in AI-driven discovery platform for DAM product evaluation and recommendation.",
  },
  {
    year: "2026-3",
    text:
      "Re-engaged with the client ASVPM.org to expand the Immersive Experience Educational Life Cycle Management platform generating performance badges for the institute's trainees through rolling out an AI-enabled automation workflow system, known as the AI Judge.",
  },
];

const stories = [
  {
    text:
      "Lead a discovery engagement to modernize and unify the client's CMS/DAM to replace a fragmented estate of 24 sites across 20 environments that published content in 25 locales and 14 languages. Conducted discovery sessions with 16 business stakeholder teams. Developed master requirements and evaluated and scored commercial platforms. Delivered implementation roadmap, migration strategy, TCO/ROI analysis, and backlog epics/stories for implementation and content migration.",
    author: "Moderna",
  },
  {
    text:
      "Spearheaded digital transformation of the client's sales and marketing digital assets through implementation of the Brandfolder DAM product. Configured the DAM platform and onboarded digital assets of 12 business units. Defined metadata standards, taxonomy hierarchy, governance policies, playbook, and lifecycle workflows. Conducted training sessions for 100+ sales and marketing staff across global locales.",
    author: "Culligan International",
  },
  {
    text:
      "Led enterprise AEM DAM transformation involving migration of 100K+ assets across 16 business units. Defined reusable content structures, metadata models, tagging, and multi-channel publishing strategy. Established DAM governance cadence and conducted training sessions for content authors.",
    author: "TD Ameritrade",
  },
];

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const isDesktop = useMediaQuery("(min-width:1201px)");
  const isTablet1 = useMediaQuery("(max-width:1360px)");
  const isTablet2 = useMediaQuery("(max-width:915px)");
  const isMobile1 = useMediaQuery("(max-width:790px)");
  const isMobile2 = useMediaQuery("(max-width:512px)");

  const [storyIndex, setStoryIndex] = useState(0);
  const [regulatedOpen, setRegulatedOpen] = useState(false);
  const [nonRegulatedOpen, setNonRegulatedOpen] = useState(false);
  const [selectedYear, setSelectedYear] = useState("2024-1");
  const VISIBLE_COUNT = isMobile2
    ? 3
    : isMobile1
    ? 4
    : isTablet2
    ? 6
    : isTablet1
    ? 8
    : 11;

  const selectedIdx = historyData.findIndex((h) => h.year === selectedYear);
  const [visibleStart, setVisibleStart] = useState(0);

  const visibleYears = historyData.slice(
    visibleStart,
    visibleStart + VISIBLE_COUNT
  );
  useEffect(() => {
    const idx = historyData.findIndex((h) => h.year === selectedYear);
    setVisibleStart(
      Math.min(
        Math.max(0, idx - Math.floor(VISIBLE_COUNT / 2)),
        historyData.length - VISIBLE_COUNT
      )
    );
  }, [VISIBLE_COUNT, selectedYear]);

  const handleTimelinePrev = () => {
    setVisibleStart((prev) => Math.max(0, prev - VISIBLE_COUNT));
  };

  const handleTimelineNext = () => {
    setVisibleStart((prev) =>
      Math.min(prev + VISIBLE_COUNT, historyData.length - VISIBLE_COUNT)
    );
  };

  const handlePrev = () => {
    setStoryIndex((prev) => prev - 1);
  };

  const handleNext = () => {
    setStoryIndex((prev) => prev + 1);
  };

  return (
    <Box>
      <Helmet>
        <title>DAM Journey - Home</title>
        <meta
          name="description"
          content="We take care, Helping organizations discover, plan, implement, and operate Digital Asset Management solutions to unlock the full value of their digital assets"
        />
        <meta
          property="keywords"
          content="DAM, DAM Journey, DAM Practice, DAM Consultant, DAM Consulting, DAM Practitioner, DAM Service, DAM Product, DAM Discovery, DAM Implementation, DAM Deployment, We take care"
        />
      </Helmet>
      {/* Hero Section - Blue Gradient */}
      <Box
        sx={{
          height: "350px",
          background: "linear-gradient(180deg, #021CA5 20%, #2A2177 90%)",
          "&::before": {
            content: '""',
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${homeHeroBanner})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
            opacity: 1,
            zIndex: 0,
          },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          px: "84px",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
          "@media (max-width: 1200px)": {
            px: "24px",
            py: "94px",
            height: "300px",
          },
          "@media (max-width: 790px)": {
            px: "16px",
            pt: "80px",
            height: "180px",
          },
        }}
      >
        <Typography
          sx={{
            fontSize: "72px", //"96px",
            "@media (max-width: 1200px)": {
              fontSize: "48px",
            },
            "@media (max-width: 790px)": {
              fontSize: "2rem",
            },
            fontWeight: 700,
            color: "#ffffff",
            lineHeight: 1.1,
            mb: 2,
            zIndex: 1,
          }}
        >
          A Premier Consulting Practice
        </Typography>
        <Typography
          sx={{
            fontSize: "24px",
            "@media (max-width: 1200px)": {
              fontSize: "20px",
            },
            "@media (max-width: 790px)": {
              fontSize: "14px",
              mb: 0,
            },
            fontWeight: 400,
            color: "#FFFFFF",
            lineHeight: 1.6,
            maxWidth: "800px",
            zIndex: 1,
            mb: 6,
          }}
        >
          Helping organizations discover, plan, implement, and operate Digital
          Asset Management solutions to unlock the full value of their assets.
        </Typography>
      </Box>

      {/* We Are Independent Section */}
      <Box
        sx={{
          height: "700px",
          px: "84px",
          "@media (max-width: 1200px)": {
            px: "24px",
            height: "373px",
            alignItems: "normal",
            py: "30px",
          },
          "@media (max-width: 790px)": {
            px: "16px",
            height: "614px",
            flexDirection: "column",
            alignItems: "center",
            py: "30px",
          },
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          position: "relative",
          overflow: "hidden",
          backgroundColor: "#FFFFFF",
          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Background watermark logo */}
        <Box
          component="img"
          src={logo}
          aria-hidden="true"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "auto",
            pointerEvents: "none",
            "@media (max-width: 1200px)": {
              width: "404px",
              height: "auto",
            },
            "@media (max-width: 790px)": {
              display: "none",
            },
          }}
        />

        {/* Title - separate for mobile ordering */}
        <Typography
          sx={{
            fontSize: "64px",
            "@media (max-width: 1200px)": {
              fontSize: "2.5rem",
            },
            fontWeight: 700,
            color: "#2A2177",
            lineHeight: 1.2,
            mb: 3,
            zIndex: 1,
            display: "none",
            "@media (max-width: 790px)": {
              display: "block",
              fontSize: "2rem",
              order: 1,
              textAlign: "center",
            },
          }}
        >
          We Are Independent
        </Typography>

        {/* Left Text Content */}
        <Box
          sx={{
            flex: 1,
            zIndex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            "@media (max-width: 1200px)": {
              pr: 0,
            },
            "@media (max-width: 790px)": {
              order: 3,
              alignItems: "center",
            },
            pr: 4,
            mb: 0,
          }}
        >
          <Typography
            sx={{
              fontSize: "64px",
              textAlign: "left",
              display: "flex",
              "@media (max-width: 1200px)": {
                fontSize: "2.5rem",
              },
              "@media (max-width: 790px)": {
                display: "none",
              },
              fontWeight: 700,
              color: "#2A2177",
              lineHeight: 1.2,
              mb: 3,
            }}
          >
            We Are Independent
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              "@media (max-width: 1200px)": {
                fontSize: "20px",
              },
              "@media (max-width: 790px)": {
                fontSize: "18px",
                textAlign: "center",
              },
              fontWeight: 400,
              color: "#666666",
              lineHeight: 1.6,
              maxWidth: "700px",
              mb: 4,
            }}
          >
            We are a vendor-neutral, vendor-agnostic, product-neutral,
            product-agnostic practice.
          </Typography>
          <Button
            variant="contained"
            endIcon={<ChevronRightIcon />}
            component={RouterLink}
            to="/product-agnostic"
            sx={{
              textTransform: "none",
              fontSize: "16px",
              fontWeight: 600,
              color: "#ffffff",
              backgroundColor: "#C22A43",
              borderRadius: "32px",
              width: "147px",
              height: "42px",
              "@media (max-width: 790px)": {
                height: "36px",
                fontSize: "0.875rem",
                width: "130px",
              },
              "&:hover": {
                backgroundColor: "#A82239",
              },
            }}
          >
            Read More
          </Button>
        </Box>

        {/* Right Infographic Image */}
        <Box
          sx={{
            flex: 1,
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "@media (max-width: 790px)": {
              order: 2,
              py: "40px",
            },
            "@keyframes spin": {
              "0%": { transform: "rotate(0deg)" },
              "100%": { transform: "rotate(360deg)" },
            },
          }}
        >
          {/* Spinning background triangle */}
          <Box
            component="img"
            src={TriangleOnWhite}
            aria-hidden="true"
            sx={{
              position: "absolute",
              width: "560px",
              height: "560px",
              "@media (max-width: 1200px)": {
                width: "300px",
                height: "300px",
              },
              "@media (max-width: 790px)": {
                width: "336px",
                height: "336px",
              },
              animation: "spin 40s linear infinite",
            }}
          />
          {/* Foreground infographic */}
          <Box
            component="img"
            src={IndependentInfographic}
            sx={{
              position: "relative",
              width: "450px",
              height: "377px",
              "@media (max-width: 1200px)": {
                width: "280px",
                height: "235px",
              },
              "@media (max-width: 790px)": {
                width: "300px",
                height: "251px",
              },
            }}
          />
        </Box>
      </Box>

      {/* We Are a Practice Section */}
      <Box
        sx={{
          height: "625px",
          px: "84px",
          "@media (max-width: 1200px)": {
            px: "24px",
            height: "423px",
            alignItems: "normal",
            pt: "30px",
          },
          "@media (max-width: 790px)": {
            px: "16px",
            height: "717px",
            display: "flex",
            flexDirection: "column",
            pt: "30px",
          },
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          position: "relative",
          overflow: "hidden",
          backgroundColor: "#F9F9F9",
          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Title - separate for mobile ordering */}
        <Typography
          sx={{
            fontSize: "64px",
            "@media (max-width: 1200px)": {
              fontSize: "2.5rem",
            },
            fontWeight: 700,
            color: "#2A2177",
            lineHeight: 1.2,
            mb: 3,
            zIndex: 1,
            display: "none",
            "@media (max-width: 790px)": {
              display: "block",
              fontSize: "2rem",
              order: 1,
              textAlign: "center",
            },
          }}
        >
          We Are a Practice
        </Typography>

        {/* Left Infographic Image */}
        <Box
          sx={{
            flex: 1,
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "@media (max-width: 1200px)": {
              pb: "100px",
            },
            "@media (max-width: 790px)": {
              order: 2,
              pt: "20px",
              pb: 0,
            },
            "@keyframes spin": {
              "0%": { transform: "rotate(0deg)" },
              "100%": { transform: "rotate(360deg)" },
            },
          }}
        >
          {/* Spinning background triangle */}
          <Box
            component="img"
            src={TriangleOnGrey}
            aria-hidden="true"
            sx={{
              position: "absolute",
              width: "560px",
              height: "560px",
              "@media (max-width: 1200px)": {
                width: "300px",
                height: "300px",
              },
              "@media (max-width: 790px)": {
                width: "336px",
                height: "336px",
              },
              animation: "spin 40s linear infinite",
            }}
          />
          {/* Foreground infographic */}
          <Box
            component="img"
            src={DAMPracticeInfographic}
            sx={{
              position: "relative",
              width: "450px",
              height: "300px",
              "@media (max-width: 1200px)": {
                width: "280px",
                height: "187px",

                alignItems: "normal",
              },
              "@media (max-width: 790px)": {
                width: "300px",
                height: "200px",
              },
            }}
          />
        </Box>

        {/* Right Text Content */}
        <Box
          sx={{
            flex: 1,
            zIndex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            pl: 4,
            "@media (max-width: 1200px)": {
              pl: 2,
            },
            "@media (max-width: 790px)": {
              order: 3,
              alignItems: "center",
              pl: 0,
            },
          }}
        >
          <Typography
            sx={{
              fontSize: "64px",
              "@media (max-width: 1200px)": {
                fontSize: "2.5rem",
              },

              "@media (max-width: 790px)": {
                display: "none",
              },

              fontWeight: 700,
              color: "#2A2177",
              lineHeight: 1.2,
              mb: 3,
            }}
          >
            We Are a Practice
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              "@media (max-width: 1200px)": {
                fontSize: "20px",
              },
              "@media (max-width: 790px)": {
                fontSize: "18px",
                textAlign: "center",
              },
              fontWeight: 400,
              color: "#666666",
              lineHeight: 1.6,
              mb: 4,
            }}
          >
            We draw a parallel with doctors, lawyers, and craft persons in terms
            of their professions. What they have in common is they have a
            practice. We also operate as a practice in the area of DAM.
          </Typography>
          <Button
            variant="contained"
            endIcon={<ChevronRightIcon />}
            component={RouterLink}
            to="/our-practice"
            sx={{
              textTransform: "none",
              fontSize: "16px",
              fontWeight: 600,
              color: "#ffffff",
              backgroundColor: "#C22A43",
              borderRadius: "32px",
              width: "147px",
              height: "42px",
              "@media (max-width: 790px)": {
                height: "36px",
                fontSize: "0.875rem",
                width: "130px",
              },
              "&:hover": {
                backgroundColor: "#A82239",
              },
            }}
          >
            Read More
          </Button>
        </Box>
      </Box>

      {/* Quote Section */}
      <Box
        sx={{
          height: "451px",
          px: "84px",
          "@media (max-width: 1200px)": {
            px: "24px",
            height: "433px",
          },
          "@media (max-width: 790px)": {
            px: "16px",
            height: "420px",
          },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#FFFFFF",
          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "351px",
            px: "60px",
            py: "48px",
            "@media (max-width: 1200px)": {
              px: "30px",
              height: "333px",
            },
            "@media (max-width: 790px)": {
              px: "16px",
              height: "360px",
            },
            borderRadius: "24px",
            background: "linear-gradient(135deg, #7b4dd1 0%, #ee88b6 100%)",

            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            {/* Quote mark image */}
            <Box
              component="img"
              src={quoteImg}
              aria-hidden="true"
              sx={{
                width: "48px",
                height: "85px",
                "@media (max-width: 1200px)": {
                  width: "34px",
                  height: "60px",
                },
                mr: "22px",
                mb: 2,
                opacity: 0.6,
              }}
            />
            <Typography
              sx={{
                fontSize: "36px",
                "@media (max-width: 1200px)": {
                  fontSize: "28px",
                },
                "@media (max-width: 790px)": {
                  fontSize: "20px",
                },
                fontStyle: "italic",
                fontWeight: 400,
                color: "#ffffff",
                lineHeight: 1.5,
                letterSpacing: 0.15,
                mb: 3,
              }}
            >
              It's through the team… bumping up against each other… and working
              together... they polish each other and polish the ideas. And what
              comes out are these really beautiful stones.
            </Typography>
          </Box>
          <Typography
            sx={{
              fontSize: "36px",
              "@media (max-width: 1200px)": {
                fontSize: "28px",
              },
              "@media (max-width: 790px)": {
                fontSize: "20px",
              },
              fontWeight: 700,
              color: "#ffffff",
              textAlign: "right",
            }}
          >
            -- Steve Jobs
          </Typography>
        </Box>
      </Box>

      {/* Immersive Experience Section */}
      <Box
        sx={{
          height: "700px",
          px: "84px",
          "@media (max-width: 1200px)": {
            px: "24px",
            height: "501px",
            alignItems: "normal",
            py: "30px",
          },
          "@media (max-width: 790px)": {
            px: "16px",
            height: "824px",
            flexDirection: "column",
            alignItems: "center",
            py: "30px",
          },
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#F9F9F9",
          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Title - separate for mobile ordering */}
        <Typography
          sx={{
            fontSize: "64px",
            "@media (max-width: 1200px)": {
              fontSize: "2.5rem",
            },
            fontWeight: 700,
            color: "#2A2177",
            lineHeight: 1.2,
            mb: 3,
            zIndex: 1,
            display: "none",
            "@media (max-width: 790px)": {
              display: "block",
              fontSize: "2rem",
              order: 1,
              textAlign: "center",
            },
          }}
        >
          Immersive Experience
          <Typography
            component="span"
            sx={{
              fontSize: "24px",
              "@media (max-width: 1200px)": {
                fontSize: "20px",
              },
              fontWeight: 700,
              color: "#2A2177",
              verticalAlign: "super",
              pl: "8px",
            }}
          >
            ®
          </Typography>
        </Typography>

        {/* Left Text Content */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            "@media (max-width: 1200px)": {
              pr: 0,
            },
            "@media (max-width: 790px)": {
              order: 3,
              alignItems: "center",
            },
            pr: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: "64px",
              textAlign: "left",
              display: "flex",
              minWidth: "710px",
              "@media (max-width: 1200px)": {
                fontSize: "2.5rem",
                letterSpacing: "-0.5px",
                minWidth: "100%",
              },
              "@media (max-width: 920px) and (min-width: 791px)": {
                minWidth: "450px",
              },
              "@media (max-width: 790px)": {
                display: "none",
              },
              fontWeight: 700,
              color: "#2A2177",
              lineHeight: 1.2,
              mb: 3,
            }}
          >
            Immersive Experience
            <Typography
              component="span"
              sx={{
                fontSize: "24px",
                "@media (max-width: 1200px)": {
                  fontSize: "20px",
                },
                fontWeight: 700,
                color: "#2A2177",
                verticalAlign: "super",
                pl: "8px",
              }}
            >
              ®
            </Typography>
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              "@media (max-width: 1200px)": {
                fontSize: "20px",
              },
              "@media (max-width: 790px)": {
                fontSize: "18px",
                textAlign: "center",
              },
              fontWeight: 400,
              color: "#666666",
              lineHeight: 1.6,
              maxWidth: "700px",
              mb: 4,
            }}
          >
            We opt in for an immersive experience. This means that we work the
            details with the DAM practitioners in your organization in a
            real-life and real-time learning journey. We accomplish this by
            executing our proprietary DAM playbook with you and your team
            members as active contributors. This also means no webinars and
            certainly no certification classes.
          </Typography>
          <Button
            variant="contained"
            endIcon={<ChevronRightIcon />}
            component={RouterLink}
            to="/immersive-experience"
            sx={{
              textTransform: "none",
              fontSize: "16px",
              fontWeight: 600,
              color: "#ffffff",
              backgroundColor: "#C22A43",
              borderRadius: "32px",
              width: "147px",
              height: "42px",
              "@media (max-width: 790px)": {
                height: "36px",
                fontSize: "0.875rem",
                width: "130px",
              },
              "&:hover": {
                backgroundColor: "#A82239",
              },
            }}
          >
            Read More
          </Button>
        </Box>

        {/* Right Infographic Image */}
        <Box
          sx={{
            flex: 1,
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "@media (max-width: 1200px)": {
              pb: "150px",
            },
            "@media (max-width: 790px)": {
              order: 2,
              pb: 0,
            },
            "@keyframes spin": {
              "0%": { transform: "rotate(0deg)" },
              "100%": { transform: "rotate(360deg)" },
            },
          }}
        >
          {/* Spinning background triangle */}
          <Box
            component="img"
            src={TriangleOnGrey}
            aria-hidden="true"
            sx={{
              position: "absolute",
              width: "560px",
              height: "560px",
              "@media (max-width: 1200px)": {
                width: "300px",
                height: "300px",
              },
              "@media (max-width: 790px)": {
                width: "336px",
                height: "336px",
              },
              animation: "spin 40s linear infinite",
            }}
          />
          {/* Foreground infographic */}
          <Box
            component="img"
            src={ImmersiveExperienceInfographic}
            sx={{
              position: "relative",
              width: "450px",
              height: "450px",
              "@media (max-width: 1200px)": {
                width: "280px",
                height: "280px",
              },
              "@media (max-width: 790px)": {
                width: "300px",
                height: "300px",
              },
            }}
          />
        </Box>
      </Box>

      {/* Data Services Section */}
      <Box
        sx={{
          height: "625px",
          px: "84px",
          "@media (max-width: 1200px)": {
            px: "24px",
            height: "422px",
            alignItems: "normal",
            py: "30px",
          },
          "@media (max-width: 790px)": {
            px: "16px",
            height: "668px",
            display: "flex",
            flexDirection: "column",
            pt: "30px",
          },
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#FFFFFF",
          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Title - separate for mobile ordering */}
        <Typography
          sx={{
            fontSize: "64px",
            "@media (max-width: 1200px)": {
              fontSize: "2.5rem",
            },
            fontWeight: 700,
            color: "#2A2177",
            lineHeight: 1.2,
            mb: 3,
            zIndex: 1,
            display: "none",
            "@media (max-width: 790px)": {
              display: "block",
              fontSize: "2rem",
              order: 1,
              textAlign: "center",
            },
          }}
        >
          Data Services
        </Typography>
        {/* Left Infographic Image */}
        <Box
          sx={{
            flex: 1,
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "@media (max-width: 1200px)": {
              pb: "80px",
            },
            "@media (max-width: 790px)": {
              order: 2,
              py: "40px",
            },
            "@keyframes spin": {
              "0%": { transform: "rotate(0deg)" },
              "100%": { transform: "rotate(360deg)" },
            },
          }}
        >
          {/* Spinning background triangle */}
          <Box
            component="img"
            src={TriangleOnWhite}
            aria-hidden="true"
            sx={{
              position: "absolute",
              width: "560px",
              height: "560px",
              "@media (max-width: 1200px)": {
                width: "300px",
                height: "300px",
              },
              "@media (max-width: 790px)": {
                width: "336px",
                height: "336px",
              },
              animation: "spin 40s linear infinite",
            }}
          />
          {/* Foreground infographic */}
          <Box
            component="img"
            src={DataServicesInfographic}
            sx={{
              position: "relative",
              width: "450px",
              height: "267px",
              "@media (max-width: 1200px)": {
                width: "280px",
                height: "166px",
              },
              "@media (max-width: 790px)": {
                width: "300px",
                height: "178px",
              },
            }}
          />
        </Box>

        {/* Right Text Content */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            pl: 4,
            "@media (max-width: 1200px)": {
              pl: 2,
            },
            "@media (max-width: 790px)": {
              order: 3,
              alignItems: "center",
              pl: 0,
            },
          }}
        >
          <Typography
            sx={{
              fontSize: "64px",
              "@media (max-width: 1200px)": {
                fontSize: "2.5rem",
              },

              "@media (max-width: 790px)": {
                display: "none",
              },

              fontWeight: 700,
              color: "#2A2177",
              lineHeight: 1.2,
              mb: 3,
            }}
          >
            Data Services
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              "@media (max-width: 1200px)": {
                fontSize: "20px",
              },
              "@media (max-width: 790px)": {
                fontSize: "18px",
                textAlign: "center",
              },
              fontWeight: 400,
              color: "#666666",
              lineHeight: 1.6,
              mb: 4,
            }}
          >
            We get our fingers dirty in the data mapping trenches by migrating
            your assets to the DAM system. We design the metadata structure and
            we build the org-wide taxonomy from the ground up.
          </Typography>
          <Button
            variant="contained"
            endIcon={<ChevronRightIcon />}
            component={RouterLink}
            to="/services"
            sx={{
              textTransform: "none",
              fontSize: "16px",
              fontWeight: 600,
              color: "#ffffff",
              backgroundColor: "#C22A43",
              borderRadius: "32px",
              width: "147px",
              height: "42px",
              "@media (max-width: 790px)": {
                height: "36px",
                fontSize: "0.875rem",
                width: "130px",
              },
              "&:hover": {
                backgroundColor: "#A82239",
              },
            }}
          >
            Read More
          </Button>
        </Box>
      </Box>

      {/* DAM Journey Section */}
      <Box
        sx={{
          height: "850px",
          px: "84px",
          pb: "60px",
          pt: "30px",
          "@media (max-width: 1200px)": {
            px: "24px",
            height: "auto",
            alignItems: "normal",
          },
          "@media (max-width: 790px)": {
            px: "16px",
            height: "auto",
            flexDirection: "column",
            alignItems: "center",
          },
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#F9F9F9",
          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Title - separate for mobile ordering */}
        <Typography
          sx={{
            fontSize: "64px",
            "@media (max-width: 1200px)": {
              fontSize: "2.5rem",
            },
            fontWeight: 700,
            color: "#2A2177",
            lineHeight: 1.2,
            mb: 3,
            zIndex: 1,
            display: "none",
            "@media (max-width: 790px)": {
              display: "block",
              fontSize: "2rem",
              order: 1,
              textAlign: "center",
            },
          }}
        >
          DAM Journey
        </Typography>

        {/* Left Text Content */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",

            "@media (max-width: 1200px)": {
              pr: 0,
              pt: "53px",
            },
            "@media (max-width: 790px)": {
              order: 3,
            },
            pr: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: "64px",
              textAlign: "left",
              display: "flex",
              "@media (max-width: 1200px)": {
                fontSize: "2.5rem",
                letterSpacing: "-0.5px",
              },
              "@media (max-width: 790px)": {
                display: "none",
              },
              fontWeight: 700,
              color: "#2A2177",
              lineHeight: 1.2,
              mb: 3,
            }}
          >
            DAM Journey
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              "@media (max-width: 1200px)": {
                fontSize: "20px",
              },
              "@media (max-width: 790px)": {
                fontSize: "18px",
                textAlign: "center",
              },
              fontWeight: 400,
              color: "#666666",
              lineHeight: 1.6,
              maxWidth: "700px",
              mb: 4,
            }}
          >
            We walk with you through you Asset Lifecycle Management Journey. The
            destinations in this journey are:
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              "@media (max-width: 1200px)": {
                fontSize: "20px",
              },
              "@media (max-width: 790px)": {
                fontSize: "18px",
              },
              fontWeight: 400,
              color: "#666666",
              lineHeight: 1.6,
              mb: 2,
            }}
          >
            Create &nbsp;»&nbsp; Manage &nbsp;»&nbsp; Distribute &nbsp;»&nbsp;
            Repurpose &nbsp;»&nbsp; Archive
          </Typography>
          <Box sx={{ mb: 4 }}>
            <Typography
              sx={{
                fontSize: "24px",
                "@media (max-width: 1200px)": {
                  fontSize: "20px",
                },
                "@media (max-width: 790px)": {
                  display: "none",
                },
                color: "#666666",
                lineHeight: 2,
              }}
            >
              Create &nbsp;&nbsp;&nbsp;&nbsp;: Design, capture, and ingest
            </Typography>
            <Typography
              sx={{
                fontSize: "24px",
                "@media (max-width: 790px)": {
                  display: "block",
                  fontSize: "18px",
                  fontWeight: "bold",
                },
                display: "none",
                color: "#666666",
                lineHeight: 1,
              }}
            >
              Create
            </Typography>
            <Typography
              sx={{
                fontSize: "24px",
                "@media (max-width: 790px)": {
                  display: "block",
                  fontSize: "18px",
                },
                display: "none",
                color: "#666666",
                lineHeight: 2,
              }}
            >
              Design, capture, and ingest
            </Typography>
            <Typography
              sx={{
                fontSize: "24px",
                "@media (max-width: 1200px)": {
                  fontSize: "20px",
                },
                "@media (max-width: 790px)": {
                  display: "none",
                },
                color: "#666666",
                lineHeight: 2,
                pt: 1,
              }}
            >
              Manage &nbsp;&nbsp;: Review, automate, and approve
            </Typography>
            <Typography
              sx={{
                fontSize: "24px",
                "@media (max-width: 790px)": {
                  display: "block",
                  fontSize: "18px",
                  fontWeight: "bold",
                  pt: 2,
                },
                display: "none",
                color: "#666666",
                lineHeight: 1,
              }}
            >
              Manage
            </Typography>
            <Typography
              sx={{
                fontSize: "24px",
                "@media (max-width: 790px)": {
                  display: "block",
                  fontSize: "18px",
                },
                display: "none",
                color: "#666666",
                lineHeight: 2,
              }}
            >
              Review, automate, and approve
            </Typography>
            <Typography
              sx={{
                fontSize: "24px",
                "@media (max-width: 1200px)": {
                  fontSize: "20px",
                },
                "@media (max-width: 790px)": {
                  display: "none",
                },
                color: "#666666",
                lineHeight: 2,
                pt: 1,
              }}
            >
              Distribute : Dynamic delivery and share
            </Typography>
            <Typography
              sx={{
                fontSize: "24px",
                "@media (max-width: 790px)": {
                  display: "block",
                  fontSize: "18px",
                  fontWeight: "bold",
                  pt: 2,
                },
                display: "none",
                color: "#666666",
                lineHeight: 1,
              }}
            >
              Distribute
            </Typography>
            <Typography
              sx={{
                fontSize: "24px",
                "@media (max-width: 790px)": {
                  display: "block",
                  fontSize: "18px",
                },
                display: "none",
                color: "#666666",
                lineHeight: 2,
              }}
            >
              Dynamic delivery and share
            </Typography>
            <Typography
              sx={{
                fontSize: "24px",
                "@media (max-width: 1200px)": {
                  fontSize: "20px",
                },
                "@media (max-width: 790px)": {
                  display: "none",
                },
                color: "#666666",
                lineHeight: 2,
                pt: 1,
              }}
            >
              Repurpose: Search, collect, and reuse
            </Typography>
            <Typography
              sx={{
                fontSize: "24px",
                "@media (max-width: 790px)": {
                  display: "block",
                  fontSize: "18px",
                  fontWeight: "bold",
                  pt: 2,
                },
                display: "none",
                color: "#666666",
                lineHeight: 1,
              }}
            >
              Repurpose
            </Typography>
            <Typography
              sx={{
                fontSize: "24px",
                "@media (max-width: 790px)": {
                  display: "block",
                  fontSize: "18px",
                },
                display: "none",
                color: "#666666",
                lineHeight: 2,
              }}
            >
              Repurpose: Search, collect, and reuse
            </Typography>
            <Typography
              sx={{
                fontSize: "24px",
                "@media (max-width: 1200px)": {
                  fontSize: "20px",
                },
                "@media (max-width: 790px)": {
                  display: "none",
                },
                color: "#666666",
                lineHeight: 2,
                pt: 1,
              }}
            >
              Archive &nbsp;&nbsp;&nbsp;: Expire and preserve
            </Typography>
            <Typography
              sx={{
                fontSize: "24px",
                "@media (max-width: 790px)": {
                  display: "block",
                  fontSize: "18px",
                  fontWeight: "bold",
                  pt: 2,
                },
                display: "none",
                color: "#666666",
                lineHeight: 1,
              }}
            >
              Archive
            </Typography>
            <Typography
              sx={{
                fontSize: "24px",
                "@media (max-width: 790px)": {
                  display: "block",
                  fontSize: "18px",
                },
                display: "none",
                color: "#666666",
                lineHeight: 2,
              }}
            >
              Expire and preserve
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              "@media (max-width: 790px)": {
                justifyContent: "center",
              },
            }}
          >
            <Button
              variant="contained"
              endIcon={<ChevronRightIcon />}
              component={RouterLink}
              to="/dam-journey"
              sx={{
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 600,
                color: "#ffffff",
                backgroundColor: "#C22A43",
                borderRadius: "32px",
                width: "147px",
                height: "42px",
                "@media (max-width: 790px)": {
                  height: "36px",
                  fontSize: "0.875rem",
                  width: "130px",
                },
                "&:hover": {
                  backgroundColor: "#A82239",
                },
              }}
            >
              Read More
            </Button>
          </Box>
        </Box>

        {/* Right Infographic Image */}
        <Box
          sx={{
            flex: 1,
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "@media (max-width: 1200px)": {
              pb: "350px",
            },
            "@media (max-width: 790px)": {
              order: 2,
              py: "40px",
            },
            "@keyframes spin": {
              "0%": { transform: "rotate(0deg)" },
              "100%": { transform: "rotate(360deg)" },
            },
          }}
        >
          {/* Spinning background triangle */}
          <Box
            component="img"
            src={TriangleOnGrey}
            aria-hidden="true"
            sx={{
              position: "absolute",
              width: "560px",
              height: "560px",
              "@media (max-width: 1200px)": {
                width: "300px",
                height: "300px",
              },
              "@media (max-width: 790px)": {
                width: "336px",
                height: "336px",
              },
              animation: "spin 40s linear infinite",
            }}
          />
          {/* Foreground infographic */}
          <Box
            component="img"
            src={DAMJourneyinfographic}
            sx={{
              position: "relative",
              width: "450px",
              height: "450px",
              "@media (max-width: 1200px)": {
                width: "280px",
                height: "280px",
              },
              "@media (max-width: 790px)": {
                width: "328px",
                height: "228px",
              },
            }}
          />
        </Box>
      </Box>

      {/* Industries We Serve Section */}
      <Box
        sx={{
          height: "867px",
          px: "84px",
          "@media (max-width: 1200px)": {
            height: "1236px",
            px: "24px",
          },
          "@media (max-width: 790px)": {
            height: "auto",
            px: "16px",
            pb: "30px",
          },
          py: "60px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "#FFFFFF",
          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Background bottomLeftDots */}
        <Box
          component="img"
          src={bottomLeftDots}
          aria-hidden="true"
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "275px",
            pointerEvents: "none",
            zIndex: 99,
            "@media (max-width: 790px)": {
              display: "none",
            },
          }}
        />
        {/* Background topRightDots */}
        <Box
          component="img"
          src={topRightDots}
          aria-hidden="true"
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            width: "275px",
            pointerEvents: "none",
            zIndex: 99,
            "@media (max-width: 790px)": {
              display: "none",
            },
          }}
        />
        <Typography
          sx={{
            fontSize: "64px",
            "@media (max-width: 1200px)": {
              fontSize: "2.5rem",
            },
            "@media (max-width: 790px)": {
              fontSize: "2rem",
            },
            fontWeight: 700,
            color: "#2A2177",
            textAlign: "center",
            mb: 2,
          }}
        >
          Industries We Serve
        </Typography>
        <Typography
          sx={{
            fontSize: "24px",
            "@media (max-width: 1200px)": {
              fontSize: "20px",
            },
            "@media (max-width: 790px)": {
              fontSize: "18px",
            },
            fontWeight: 400,
            color: "#666666",
            textAlign: "center",
            lineHeight: 1.6,
            maxWidth: "744px",
            mb: 4,
            zIndex: 100,
          }}
        >
          We bring intelligent DAM solutions to leaders in Media &
          Entertainment, Consumer Products -- and other regulated and
          non-regulated sectors -- where compliance, agility, and scalability
          are paramount.
        </Typography>

        {/* Two Boxes */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            "@media (max-width: 1200px)": {
              flexDirection: "column",
            },
            gap: 3,
            width: "100%",
            justifyContent: "center",
            zIndex: 100,
          }}
        >
          {/* Regulated Industries Box */}
          <Box
            sx={{
              width: "516px",
              height: "456px",
              background: "linear-gradient(180deg, #F9F9F9 0%, #FFF5FA 100%)",
              borderRadius: "20px",
              p: "24px",
              pt: "12px",
              "@media (max-width: 1200px)": {
                width: "100%",
              },
              "@media (max-width: 790px)": {
                height: "auto",
                width: "100%",
                p: "16px",
              },
            }}
          >
            {/* Header */}
            <Box
              onClick={() => isMobile1 && setRegulatedOpen(!regulatedOpen)}
              sx={{
                display: "flex",
                alignItems: "center",
                height: "96px",
                gap: 2,
                mb: 3,
                "@media (max-width: 790px)": {
                  mb: regulatedOpen ? 2 : 0,
                  height: "64px",
                  cursor: "pointer",
                  borderBottom: regulatedOpen ? "1px solid #0000001A" : "none",
                },
                borderBottom: "1px solid #0000001A",
              }}
            >
              <Box
                sx={{
                  width: "72px",
                  height: "72px",
                  "@media (max-width: 790px)": {
                    width: "48px",
                    height: "48px",
                  },
                  borderRadius: "50%",
                  backgroundColor: "#F1ECFD",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <VerifiedUserOutlinedIcon
                  sx={{
                    fontSize: 40,
                    "@media (max-width: 790px)": {
                      fontSize: 24,
                    },
                    color: "#8758CE",
                  }}
                />
              </Box>
              <Typography
                sx={{
                  fontSize: "1.5rem",
                  "@media (max-width: 790px)": {
                    fontSize: "18px",
                  },
                  fontWeight: 600,
                  color: "#2A2177",
                  flex: 1,
                }}
              >
                Regulated Industries
              </Typography>
              {isMobile1 &&
                (regulatedOpen ? (
                  <KeyboardArrowUpOutlinedIcon sx={{ color: "#666" }} />
                ) : (
                  <KeyboardArrowDownOutlinedIcon sx={{ color: "#666" }} />
                ))}
            </Box>

            {/* Industry Items Grid */}
            <Collapse in={isMobile1 ? regulatedOpen : true} timeout="auto">
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  "@media (max-width: 790px)": {
                    gridTemplateColumns: "1fr",
                    gap: "16px",
                  },
                  gap: 3,
                }}
              >
                {[
                  {
                    icon: TrendingUpOutlinedIcon,
                    label: "Finance & Wealth Management",
                  },
                  {
                    icon: AccountBalanceOutlinedIcon,
                    label: "Government & Public Sector",
                  },
                  { icon: LocalHospitalOutlinedIcon, label: "Healthcare" },
                  { icon: BiotechOutlinedIcon, label: "Life Sciences" },
                  {
                    icon: SignalCellularAltOutlinedIcon,
                    label: "Telecommunication",
                  },
                  { icon: ElectricBoltOutlinedIcon, label: "Utilities" },
                ].map((item, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      backgroundColor: "#FFFFFF",
                      borderRadius: "8px",
                      height: "80px",
                      px: 2,
                      py: 1.5,
                      boxShadow: "0px 1px 3px 0px #00000029",
                      ...gradientHoverSx,
                    }}
                  >
                    <Box
                      sx={{
                        width: "48px",
                        height: "48px",
                        minWidth: "48px",
                        borderRadius: "50%",
                        backgroundColor: "#F6F2FE",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <GradientIcon
                        icon={item.icon}
                        size={24}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      />
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "0.875rem",
                        fontWeight: "medium",
                        color: "#2A2177",
                        lineHeight: 1.5,
                      }}
                    >
                      {item.label}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Collapse>
          </Box>

          {/* Non-regulated Industries Box */}
          <Box
            sx={{
              width: "732px",
              "@media (max-width: 1200px)": {
                width: "100%",
              },
              height: "456px",
              background: "linear-gradient(180deg, #F9F9F9 0%, #F7F3FF 100%)",
              borderRadius: "20px",
              p: "24px",
              pt: "12px",
              "@media (max-width: 790px)": {
                height: "auto",
                width: "100%",
                p: "16px",
              },
            }}
          >
            {/* Header */}
            <Box
              onClick={() =>
                isMobile1 && setNonRegulatedOpen(!nonRegulatedOpen)
              }
              sx={{
                display: "flex",
                alignItems: "center",
                height: "96px",
                "@media (max-width: 790px)": {
                  mb: nonRegulatedOpen ? 2 : 0,
                  height: "64px",
                  cursor: "pointer",
                  borderBottom: nonRegulatedOpen
                    ? "1px solid #0000001A"
                    : "none",
                },
                gap: 2,
                mb: 3,
                borderBottom: "1px solid #0000001A",
              }}
            >
              <Box
                sx={{
                  width: "72px",
                  height: "72px",
                  "@media (max-width: 790px)": {
                    width: "48px",
                    height: "48px",
                  },
                  borderRadius: "50%",
                  backgroundColor: "#F1ECFD",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <LanguageOutlinedIcon
                  sx={{
                    fontSize: 40,
                    "@media (max-width: 790px)": {
                      fontSize: 24,
                    },
                    color: "#8758CE",
                  }}
                />
              </Box>
              <Typography
                sx={{
                  fontSize: "1.5rem",
                  fontWeight: 600,
                  color: "#2A2177",
                  flex: 1,
                  "@media (max-width: 790px)": {
                    fontSize: "18px",
                  },
                }}
              >
                Non-regulated Industries
              </Typography>
              {isMobile1 &&
                (nonRegulatedOpen ? (
                  <KeyboardArrowUpOutlinedIcon sx={{ color: "#666" }} />
                ) : (
                  <KeyboardArrowDownOutlinedIcon sx={{ color: "#666" }} />
                ))}
            </Box>

            {/* Industry Items Grid */}
            <Collapse in={isMobile1 ? nonRegulatedOpen : true} timeout="auto">
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  "@media (max-width: 790px)": {
                    gridTemplateColumns: "1fr",
                    gap: "16px",
                  },
                  gap: 3,
                }}
              >
                {[
                  { icon: ShoppingCartOutlinedIcon, label: "eCommerce" },
                  { icon: SchoolOutlinedIcon, label: "Education" },
                  { icon: ElectricBoltOutlinedIcon, label: "Energy & Power" },
                  { icon: PlayCircleOutlinedIcon, label: "Entertainment" },
                  { icon: EventOutlinedIcon, label: "Events Management" },
                  { icon: NewspaperOutlinedIcon, label: "News Media" },
                  { icon: StorefrontOutlinedIcon, label: "Retail" },
                  { icon: ForumOutlinedIcon, label: "Social Media" },
                  { icon: MemoryOutlinedIcon, label: "Technology" },
                ].map((item, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      backgroundColor: "#FFFFFF",
                      borderRadius: "8px",
                      height: "80px",
                      px: 2,
                      py: 1.5,
                      boxShadow: "0px 1px 3px 0px #00000029",
                      ...gradientHoverSx,
                    }}
                  >
                    <Box
                      sx={{
                        width: "48px",
                        height: "48px",
                        minWidth: "48px",
                        borderRadius: "50%",
                        backgroundColor: "#F6F2FE",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <GradientIcon
                        icon={item.icon}
                        size={24}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      />
                    </Box>
                    <Typography
                      sx={{ fontSize: "14px", fontWeight: 500, color: "#333" }}
                    >
                      {item.label}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Collapse>
          </Box>
        </Box>
      </Box>

      {/* Success Stories Section */}
      <Box
        sx={{
          height: "auto",
          px: "84px",
          "@media (max-width: 1200px)": {
            px: "24px",
          },
          "@media (max-width: 790px)": {
            px: "16px",
            py: "30px",
          },
          py: "50px",
          backgroundColor: "#F9F9F9",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography
          sx={{
            fontSize: "64px",
            "@media (max-width: 1200px)": {
              fontSize: "2.5rem",
            },
            "@media (max-width: 790px)": {
              fontSize: "2rem",
            },
            fontWeight: 700,
            color: "#2A2177",
            textAlign: "center",
          }}
        >
          Success Stories
        </Typography>
        <Typography
          sx={{
            fontSize: "24px",
            "@media (max-width: 1200px)": {
              fontSize: "20px",
              pb: 5,
            },
            "@media (max-width: 790px)": {
              fontSize: "18px",
              pb: 2,
            },
            fontWeight: 400,
            color: "#666666",
            textAlign: "center",
          }}
        >
          Real results achieved through innovation and collaboration.
        </Typography>

        {/* Story Carousel */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            gap: 4,
          }}
        >
          {/* Left Arrow */}
          <IconButton
            onClick={handlePrev}
            disabled={storyIndex === 0}
            sx={{
              width: "48px",
              height: "48px",
              "@media (max-width: 790px)": {
                width: "32px",
                height: "32px",
              },
              border: "1px solid rgba(0, 0, 0, 0.16)",
              borderRadius: "50%",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
              "&.Mui-disabled": {
                opacity: 0.3,
                border: "1px solid rgba(0, 0, 0, 0.08)",
              },
            }}
            aria-label="Previous story"
          >
            <ChevronLeftIcon
              sx={{
                fontSize: 32,
                "@media (max-width: 1200px)": { fontSize: "24px" },
                color: "#333",
              }}
            />
          </IconButton>

          {/* Story Card */}
          <Box
            sx={{
              minHeight: "200px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              width: "100%",
              "@media (max-width: 790px)": { px: 0 },
              px: 3,
            }}
          >
            <Box
              sx={{
                minHeight: "110px",
                "@media (min-width: 1199px)": { mt: "20px" },
              }}
            >
              <Typography
                sx={{
                  fontSize: "24px",
                  "@media (max-width: 790px)": {
                    fontSize: "0.875rem",
                  },
                  fontWeight: 400,
                  color: "#666666",
                  lineHeight: 1.5,
                  mb: 3,
                }}
              >
                {stories[storyIndex].text}
              </Typography>
            </Box>
            <Typography
              sx={{
                fontSize: "16px",
                "@media (max-width: 790px)": {
                  fontSize: "0.875rem",
                },
                fontWeight: 700,
                color: "#1A1A2E",
              }}
            >
              {stories[storyIndex].author}
            </Typography>
          </Box>

          {/* Right Arrow */}
          <IconButton
            onClick={handleNext}
            disabled={storyIndex === stories.length - 1}
            sx={{
              width: "48px",
              height: "48px",
              border: "1px solid rgba(0, 0, 0, 0.16)",
              borderRadius: "50%",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
              "&.Mui-disabled": {
                opacity: 0.3,
                border: "1px solid rgba(0, 0, 0, 0.08)",
              },
              "@media (max-width: 790px)": {
                width: "32px",
                height: "32px",
              },
            }}
            aria-label="Next story"
          >
            <ChevronRightIcon
              sx={{
                fontSize: 32,
                "@media (max-width: 1200px)": { fontSize: "24px" },
                color: "#333",
              }}
            />
          </IconButton>
        </Box>
      </Box>
      {/* Quote Section 2 */}
      <Box
        sx={{
          height: "397px",
          px: "84px",
          "@media (max-width: 1200px)": {
            height: "349px",
            px: "24px",
          },
          "@media (max-width: 790px)": {
            height: "300px",
            px: "16px",
          },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#FFFFFF",
          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "297px",
            "@media (max-width: 1200px)": {
              height: "249px",
              px: "30px",
            },
            "@media (max-width: 790px)": {
              height: "240px",
              px: "16px",
            },
            px: "60px",
            py: "48px",
            borderRadius: "24px",
            background: "linear-gradient(135deg, #7b4dd1 0%, #ee88b6 100%)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            {/* Quote mark image */}
            <Box
              component="img"
              src={quoteImg}
              aria-hidden="true"
              sx={{
                width: "48px",
                height: "85px",
                "@media (max-width: 1200px)": {
                  width: "34px",
                  height: "60px",
                },
                mr: "22px",
                mb: 2,
                opacity: 0.6,
              }}
            />
            <Typography
              sx={{
                fontSize: "36px",
                "@media (max-width: 1200px)": {
                  fontSize: "28px",
                },
                "@media (max-width: 790px)": {
                  fontSize: "20px",
                },
                fontStyle: "italic",
                fontWeight: 400,
                color: "#ffffff",
                lineHeight: 1.5,
                letterSpacing: 0.15,
                mb: 3,
              }}
            >
              I'm on this journey with you. I'm not here to do this journey at
              you. I'm in this with you.
            </Typography>
          </Box>
          <Typography
            sx={{
              fontSize: "36px",
              "@media (max-width: 1200px)": {
                fontSize: "28px",
              },
              "@media (max-width: 790px)": {
                fontSize: "20px",
              },
              fontWeight: 700,
              color: "#ffffff",
              textAlign: "right",
            }}
          >
            -- Claire Clark
          </Typography>
        </Box>
      </Box>

      {/* DAM Discovery Framework Section */}
      <Box
        sx={{
          height: "341px",
          px: "84px",
          "@media (max-width: 1200px)": {
            height: "332px",
            px: "24px",
          },
          "@media (max-width: 790px)": {
            height: "350px",
            px: "16px",
          },
          background: "linear-gradient(180deg, #FFFFFF 0%, #FFE7EB 100%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography
          sx={{
            fontSize: "64px",
            "@media (max-width: 1200px)": {
              fontSize: "2.5rem",
            },
            "@media (max-width: 790px)": {
              fontSize: "2rem",
            },
            fontWeight: 700,
            color: "#2A2177",
            mb: 2,
          }}
        >
          DAM Discovery Framework
          <Typography
            component="span"
            sx={{
              fontSize: "24px",
              "@media (max-width: 1200px)": {
                fontSize: "20px",
              },

              fontWeight: 700,
              color: "#2A2177",
              verticalAlign: "super",
              paddingBottom: "5px",
            }}
          >
            ™
          </Typography>
        </Typography>
        <Typography
          sx={{
            fontSize: "24px",
            "@media (max-width: 1200px)": {
              fontSize: "20px",
            },
            "@media (max-width: 790px)": {
              fontSize: "18px",
            },
            fontWeight: 400,
            color: "rgba(0, 0, 0, 0.87)",
            lineHeight: 1.6,
            mb: 4,
          }}
        >
          Startup Framework gives you complete freedom over your creative
          process — you don't have to think about any technical aspects. There
          are no limits and absolutely no coding.
        </Typography>
        <Button
          variant="contained"
          endIcon={<ChevronRightIcon />}
          component={RouterLink}
          to="/discovery-framework"
          sx={{
            textTransform: "none",
            fontSize: "16px",
            fontWeight: 600,
            color: "#ffffff",
            backgroundColor: "#C22A43",
            borderRadius: "32px",
            width: "147px",
            height: "42px",
            "@media (max-width: 790px)": {
              height: "36px",
              fontSize: "0.875rem",
              width: "130px",
            },
            "&:hover": {
              backgroundColor: "#A82239",
            },
          }}
        >
          Read More
        </Button>
      </Box>

      {/* Our History Section */}
      <Box
        sx={{
          height: "850px",
          px: "84px",
          "@media (max-width: 1200px)": {
            height: "auto",
            px: "24px",
          },
          "@media (max-width: 790px)": {
            height: "auto",
            px: "16px",
            pt: "30px",
            pb: "50px",
          },
          py: "60px",
          backgroundColor: "#FFFFFF",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography
          sx={{
            fontSize: "64px",
            "@media (max-width: 1200px)": {
              fontSize: "2.5rem",
            },
            "@media (max-width: 790px)": {
              fontSize: "2rem",
              mb: 2,
            },
            fontWeight: 700,
            color: "#2A2177",
            textAlign: "center",
            mb: 4,
          }}
        >
          Our History
        </Typography>
        <Typography
          sx={{
            fontSize: "24px",
            "@media (max-width: 1200px)": {
              fontSize: "20px",
            },
            "@media (max-width: 790px)": {
              fontSize: "18px",
              mb: 4,
            },
            fontWeight: 400,
            color: "#666666",
            textAlign: "center",
            lineHeight: 1.6,
            mb: 10,
          }}
        >
          We have a long and prosperous history serving clients like you. Our
          value proposition from the inception has been to listen and work with
          you to implement solutions.
        </Typography>

        {/* History Card */}
        <Box
          sx={{
            width: "100%",
            height: "auto",
            minHeight: "360px",
            "@media (max-width: 1200px)": {
              minHeight: "300px",
            },
            "@media (max-width: 790px)": {
              flexDirection: "column",
              height: "auto",
              minHeight: "280px",
              px: "16px",
              pb: 2,
            },
            backgroundColor: "#FAFAFA",
            borderRadius: "16px",
            border: "1px solid #2A2177",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            px: "48px",
            mb: 8,
          }}
        >
          <Typography
            sx={{
              fontSize: "64px",
              fontWeight: 700,
              color: "#2A2177",
              minWidth: "210px",
              "@media (max-width: 790px)": {
                textAlign: "center",
                minWidth: "unset",
                width: "100%",
              },
            }}
          >
            {selectedYear}
          </Typography>
          <Box sx={{ width: "10px" }}>
            <Box
              sx={{
                width: "8px",
                height: "92px",
                maxWidth: "933px",
                backgroundColor: "#2A2177",
                mx: 2,
                "@media (max-width: 790px)": {
                  display: "none",
                },
              }}
            />
          </Box>
          <Typography
            sx={{
              fontSize: "24px",
              "@media (max-width: 790px)": {
                fontSize: "18px",
                pl: 0,
                textAlign: "left",
                lineHeight: 1.3,
              },
              fontWeight: 400,
              color: "#666666",
              lineHeight: 1.6,
              pl: 6,
            }}
          >
            {(() => {
              const item = historyData.find((h) => h.year === selectedYear);
              return isMobile1 && item?.mobileText
                ? item.mobileText
                : item?.text;
            })()}
          </Typography>
        </Box>

        {/* Timeline */}
        <Box
          sx={{
            width: "100%",
            //maxWidth: "1272px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            position: "relative",
          }}
        >
          {/* Left Arrow */}
          <IconButton
            onClick={handleTimelinePrev}
            disabled={visibleStart === 0}
            sx={{
              width: "32px",
              height: "32px",
              "&.Mui-disabled": { opacity: 0.3 },
            }}
            aria-label="Previous year"
          >
            <ChevronLeftIcon sx={{ fontSize: 24, color: "#333" }} />
          </IconButton>

          {/* Timeline Line + Years */}
          <Box
            sx={{
              flex: 1,
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
              overflow: "hidden",
            }}
          >
            {/* Years */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mb: 1,
                ml: 1,
              }}
            >
              {visibleYears.map((item) => (
                <Typography
                  key={item.year}
                  onClick={() => setSelectedYear(item.year)}
                  sx={{
                    fontSize: "1.5rem",
                    fontWeight: selectedYear === item.year ? 700 : 400,
                    color: selectedYear === item.year ? "#2A2177" : "#999999",
                    cursor: "pointer",
                    textAlign: "center",
                    minWidth: "100px",
                    "&:hover": {
                      color: "#2A2177",
                    },
                  }}
                >
                  {item.year}
                </Typography>
              ))}
            </Box>

            {/* Line with dots */}
            <Box
              sx={{
                px: "45px",
                position: "relative",
                height: "12px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "-5px",
                  right: "-5px",
                  height: "2px",
                  backgroundColor: "rgba(0, 0, 0, 0.12)",
                  transform: "translateY(-50%)",
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  position: "relative",
                }}
              >
                {visibleYears.map((item) => (
                  <Box
                    key={item.year}
                    onClick={() => setSelectedYear(item.year)}
                    sx={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      backgroundColor:
                        selectedYear === item.year ? "#2A2177" : "#FFFFFF",
                      border:
                        selectedYear === item.year
                          ? "none"
                          : "2px solid rgba(0, 0, 0, 0.2)",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                    }}
                  />
                ))}
              </Box>
            </Box>
          </Box>

          {/* Right Arrow */}
          <IconButton
            onClick={handleTimelineNext}
            disabled={visibleStart >= historyData.length - VISIBLE_COUNT}
            sx={{
              width: "32px",
              height: "32px",
              "&.Mui-disabled": { opacity: 0.3 },
            }}
            aria-label="Next year"
          >
            <ChevronRightIcon sx={{ fontSize: 24, color: "#333" }} />
          </IconButton>
        </Box>
      </Box>
      {/* Have Questions Section */}
      <Box
        sx={
          {
            /* maxWidth: "1440px"*/
          }
        }
      >
        <HaveQuestions />
      </Box>
    </Box>
  );
};

export default HomePage;
